import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { getLoggedInUser } from '../../../redux/auth/authActions';
import { clearState } from '../../../redux/auth/slices/login';
import Avatar from '../../../components/uiElements/avatar';
import { User, Settings, Power } from 'react-feather';
import { Dropdown, DropdownMenu, DropdownToggle, DropdownItem } from 'reactstrap';

const UserDropdown = () => {
  const dispatch = useDispatch();
  const [dropdownOpen, setDropdownOpen] = useState(false);

  const toggle = () => setDropdownOpen((prevState) => !prevState);

  useEffect(() => {
    dispatch(getLoggedInUser());
  }, [dispatch]);

  const { loggedInUser } = useSelector((state) => state.auth?.login);

  return (
    <Dropdown tag="li" className="dropdown-user nav-item" isOpen={dropdownOpen} toggle={toggle}>
      <DropdownToggle
        href="/"
        tag="a"
        className="nav-link dropdown-user-link"
        onClick={(e) => e.preventDefault()}>
        <div className="user-nav d-sm-flex d-none">
          <span className="user-name fw-bold">{
            loggedInUser?.username
          }</span>
        </div>
        <Avatar imgHeight="40" imgWidth="40" content={loggedInUser?.username} />
      </DropdownToggle>
      <DropdownMenu end>
        <DropdownItem tag={Link} to="">
          <User size={14} className="me-75" />
          <span className="align-middle">Profile</span>
        </DropdownItem>

        <DropdownItem divider />
        <DropdownItem tag={Link} to="/pages/account-settings">
          <Settings size={14} className="me-75" />
          <span className="align-middle">Settings</span>
        </DropdownItem>
        <DropdownItem tag={Link} to="/login" onClick={() => dispatch(clearState())}>
          <Power size={14} className="me-75" />
          <span className="align-middle">Logout</span>
        </DropdownItem>
      </DropdownMenu>
    </Dropdown>
  );
};

export default UserDropdown;
